<template>
  <div class="builder">
    <Collection v-if="collectionPanelOpen" class="left-panel"/>
    <Properties v-if="movePanelOpen" v-model="selectedMove" class="right-panel" @deleteMove="deleteMove"/>
    <Settings v-if="settingsPanelOpen" v-model="settings" class="right-panel"/>
    <Organizer ref="organizer" v-model="routine" class="central-panel" @unselectMove="closeRightPanel" @selectMove="openMovePropertiesPanel">
      <Menu class="floating-menu"
                      @toggleCollection="collectionPanelOpen = !collectionPanelOpen"
                      @toggleSettings="toggleSettingsPanel"
                      @load="loadRoutine"
                      @save="saveRoutine"
                      @play="playRoutine"/>
    </Organizer>
  </div>
</template>

<script>
import Collection from '@/components/builder/Collection'
import Organizer from '@/components/builder/Organizer'
import Properties from '@/components/builder/Properties'
import Settings from '@/components/builder/Settings'
import Menu from '@/components/builder/Menu'
export default {
  name: 'Builder',
  components: { Menu, Settings, Properties, Organizer, Collection },
  data () {
    return {
      movePanelOpen: false,
      settingsPanelOpen: false,
      collectionPanelOpen: false,
      selectedMove: {},
      settings: {
        name: 'myRoutine',
        restingTime: 20
      },
      routine: []
    }
  },
  computed: {
    allRoutines () {
      return JSON.parse(localStorage.getItem('routines')) || {}
    }
  },
  methods: {

    closeRightPanel () {
      this.movePanelOpen = false
    },
    openMovePropertiesPanel ($event) {
      this.settingsPanelOpen = false
      this.movePanelOpen = true
      this.selectedIndex = $event.index
      this.selectedMove = $event.move
    },
    deleteMove () {
      this.$refs.organizer.routine.splice(this.selectedIndex, 1)
      this.movePanelOpen = false
    },
    toggleSettingsPanel () {
      this.movePanelOpen = false
      this.settingsPanelOpen = !this.settingsPanelOpen
    },
    loadRoutine (selectedName) {
      console.log('LOAD')
      this.$refs.organizer.routine = this.allRoutines[selectedName].moves
      this.settings = this.allRoutines[selectedName].settings
    },
    saveRoutine () {
      console.log('SAVE')
      const allRoutines = this.allRoutines
      allRoutines[this.settings.name] = { moves: this.routine, settings: this.settings }
      localStorage.setItem('routines', JSON.stringify(allRoutines))
    },
    playRoutine () {
      console.log('PLAY')
    }
  },
  created () {
    const allRoutines = this.allRoutines
    allRoutines.RoutineBabOu = { moves: [{ name: 'Dog', timed: true, time: 40, step: 10, thumbnail: 'images/yoga/dog.png', id: '5c15e08266fe88', index: 0 }, { name: 'Push up', counted: true, timed: true, time: 40, count: 10, step: 2, thumbnail: 'images/intensive/push_up.png', id: '5c15e9254d0e14', index: 1 }, { name: 'Warrior 1', timed: true, time: 40, step: 10, thumbnail: 'images/yoga/warrior_1.png', id: '5c15e05b66395c', index: 2 }, { name: 'Abs', counted: true, timed: true, time: 40, count: 10, step: 2, thumbnail: 'images/intensive/abs.png', id: '5c15e92d4fb228', index: 3 }, { name: 'Bird Dog', timed: true, time: 40, step: 10, thumbnail: 'images/yoga/bird_dog.png', id: '5c15e07cf19fec', index: 4 }, { name: 'Chair', timed: true, time: 40, step: 10, thumbnail: 'images/yoga/chair.png', id: '5c15e0675ac4ac', index: 5 }, { name: 'Warrior 2', timed: true, time: 40, step: 10, thumbnail: 'images/yoga/warrior_2.png', id: '5c15e097b6d344', index: 6 }, { name: 'Pull up', counted: true, time: 40, count: 10, step: 2, thumbnail: 'images/intensive/pull_up.png', id: '5c15e93c55d9fc', index: 7 }, { name: 'Butterfly', timed: true, time: 40, step: 10, thumbnail: 'images/yoga/butterfly.png', id: '5c15e073569868', index: 8 }, { name: 'Plank', counted: true, timed: true, time: 40, count: 10, step: 2, thumbnail: 'images/intensive/plank.png', id: '5c15e94747980c', index: 9 }, { name: 'Dog', timed: true, time: 40, step: 10, thumbnail: 'images/yoga/dog.png', id: '5c15e1b99c4ec0', index: 10 }, { name: 'Push up', counted: true, timed: true, time: 40, count: 10, step: 2, thumbnail: 'images/intensive/push_up.png', id: '5c15e9566b01b8', index: 11 }, { name: 'Wheel', timed: true, time: 40, step: 10, thumbnail: 'images/yoga/wheel.png', id: '5c15e0f1d33d74', index: 12 }, { name: 'Star', counted: true, timed: true, time: 40, count: 10, step: 2, thumbnail: 'images/intensive/star.png', id: '5c15e966825d18', index: 13 }, { name: 'Tree', timed: true, time: 40, step: 10, thumbnail: 'images/yoga/tree.png', id: '5c15e09d9829d4', index: 14 }, { name: 'Rope', counted: true, timed: true, time: 40, count: 10, step: 2, thumbnail: 'images/intensive/rope.png', id: '5c15e96d97600c', index: 15 }, { name: 'Dancer', timed: true, time: 40, step: 10, thumbnail: 'images/yoga/dancer.png', id: '5c15e0d0a9fdf0', index: 16 }, { name: 'Abs', counted: true, timed: true, time: 40, count: 10, step: 2, thumbnail: 'images/intensive/abs.png', id: '5c15e974e9efe8', index: 17 }, { name: 'Shoulder stand', timed: true, time: 40, step: 10, thumbnail: 'images/yoga/shoulder_stand.png', id: '5c15e1018c1b7c', index: 18 }, { name: 'Butterfly', timed: true, time: 40, step: 10, thumbnail: 'images/yoga/butterfly.png', id: '5c15e10ad2d328', index: 19 }], settings: { name: 'Routine', restingTime: 20 } }
    localStorage.setItem('routines', JSON.stringify(allRoutines))
  }
}
</script>

<style scoped lang="scss">
  .builder {
    height: 100%;
    display:flex;

    .left-panel {
      order:1;
      flex: 0 0 150px;
      border: 1px solid red;
    }

    .central-panel {
      position:relative;
      order:2;
      flex: 1 0;
      border: 1px solid red;
    }

    .right-panel {
      order:3;
      flex: 0 0 400px;
      border: 1px solid red;
    }

    .floating-menu {
      position:absolute;
      top:0;
      width:100%;
    }
  }
</style>
